import React from 'react';

/**
 * Componente de botões de navegação para o fluxo de agendamento
 * 
 * @param {Object} props - Propriedades do componente
 * @param {Function} props.onBack - Função chamada ao clicar em Voltar
 * @param {Function} props.onContinue - Função chamada ao clicar em Continuar
 * @param {boolean} props.showBack - Se deve mostrar o botão Voltar
 * @param {boolean} props.continueDisabled - Se o botão Continuar deve estar desabilitado
 * @param {string} props.continueLabel - Texto do botão Continuar
 * @param {string} props.backLabel - Texto do botão Voltar
 * @param {string} props.primaryColor - Cor primária para o botão Continuar
 * @param {string} props.theme - Tema dos botões ('public' ou 'admin')
 * @param {boolean} props.isAdmin - Indica se está no modo admin
 */
const NavigationButtons = ({ 
  onBack, 
  onContinue,
  showBack = true,
  continueDisabled = false,
  continueLabel = "Continuar",
  backLabel = "Voltar",
  primaryColor = '#4F46E5',
  theme = 'public',
  isAdmin = false
}) => {
  // Se estiver no modo admin, usar azul em vez da cor primária
  const activeColor = isAdmin ? '#3B82F6' : primaryColor;
  
  // Estilos de botões para diferentes temas
  const buttonStyles = {
    public: {
      continue: "w-full sm:w-auto px-6 py-3 rounded-lg text-white font-medium hover:opacity-90 transition-opacity",
      back: "w-full sm:w-auto px-6 py-3 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition-colors",
      disabledContinue: "opacity-50 cursor-not-allowed",
    },
    admin: {
      continue: isAdmin 
        ? "w-full sm:w-auto px-4 py-2 rounded border-2 border-blue-500 bg-blue-50 text-blue-800 font-medium text-sm hover:bg-blue-100 transition-colors" 
        : "w-full sm:w-auto px-4 py-2 rounded text-white font-medium text-sm hover:opacity-90 transition-opacity",
      back: "w-full sm:w-auto px-4 py-2 rounded font-medium text-sm text-gray-600 hover:bg-gray-100 transition-colors",
      disabledContinue: "opacity-50 cursor-not-allowed",
    }
  };
  
  // Determinar o estilo a usar com base no tema e se é admin
  const currentTheme = theme === 'admin' && isAdmin ? 'admin' : theme;
  
  return (
    <div className="flex flex-col sm:flex-row justify-between mt-6 space-y-3 sm:space-y-0 sm:space-x-3">
      {showBack && (
        <button 
          type="button"
          onClick={onBack}
          className={buttonStyles[currentTheme].back}
        >
          {backLabel}
        </button>
      )}
      
      <button 
        type="button"
        onClick={onContinue}
        disabled={continueDisabled}
        className={`${buttonStyles[currentTheme].continue} ${continueDisabled ? buttonStyles[currentTheme].disabledContinue : ''}`}
        style={!isAdmin && theme !== 'admin' ? { backgroundColor: continueDisabled ? undefined : activeColor } : {}}
      >
        {continueLabel}
      </button>
    </div>
  );
};

export default NavigationButtons; 